import { render } from "./McpToolPermissionPrompt.vue?vue&type=template&id=709f39ec&scoped=true"
import script from "./McpToolPermissionPrompt.vue?vue&type=script&lang=js"
export * from "./McpToolPermissionPrompt.vue?vue&type=script&lang=js"

import "./McpToolPermissionPrompt.vue?vue&type=style&index=0&id=709f39ec&scoped=true&lang=css"
import "./McpToolPermissionPrompt.vue?vue&type=style&index=1&id=709f39ec&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709f39ec"]])

export default __exports__